<template>
    <div id="payment-posting-container">
        <div class="page-height">
            <b-row>
                <b-col>
                    <MdTitle
                        v-bind:Text="
                            editMode
                                ? $t('PostPayment.Manual.TitleEdit')
                                : $t('PostPayment.Manual.TitleAdd')
                        "
                    />
                </b-col>
            </b-row>
        </div>

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="gotoBackHandler"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'ManualPaymentPosting',
    data() {
        return {};
    },
    computed: {
        editMode() {
            return this.$attrs.editMode;
        },
        isPatientPaymentSource() {
            return (this.$attrs.source || '').toLowerCase() === 'patient';
        }
    },
    methods: {
        gotoBackHandler() {
            this.$router.push({ name: 'manual-payment-posting' });
        }
    }
};
</script>
